module.exports = __webpack_public_path__ + "img/lookbook_16_right.95bb6250.png";